import { createSlice } from "@reduxjs/toolkit";
import {
  getOrderById,
  getOrderList,
  getForwardOrderItems,
  updateOrder, // ✅ imported
} from "./ThunkActions";
import { iOrderState, REDUCER_NAME } from "./Types";

const extractOrderList = (payload: any) => {
  const source = payload?.data;
  if (Array.isArray(source?.orders)) return source.orders;
  if (Array.isArray(source?.order)) return source.order;
  if (Array.isArray(source?.data?.orders)) return source.data.orders;
  if (Array.isArray(source?.data?.order)) return source.data.order;
  if (Array.isArray(source?.data)) return source.data;
  return [];
};

const initialState: iOrderState = {
  isLoading: false,
  orders: null,
  errorMessage: null,
  orderList: [],
  forwardItems: null,
};

export const orderSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    resetOrderState: () => {
      return initialState;
    },
    clearForwardOrderItems: (state) => {
      state.forwardItems = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // ✅ getOrderById
      .addCase(getOrderById.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getOrderById.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.orders = payload.data.orders;
        }
        state.isLoading = false;
      })
      .addCase(getOrderById.rejected, (state, action) => {
        state.errorMessage = "Failed to fetch order data";
        state.isLoading = false;
      })

      // ✅ getOrderList
      .addCase(getOrderList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getOrderList.fulfilled, (state, action) => {
        const payload = action.payload;
        state.orderList = extractOrderList(payload);
        state.isLoading = false;
        state.errorMessage = null;
      })
      .addCase(getOrderList.rejected, (state, action) => {
        state.errorMessage = "Failed to fetch order list";
        state.isLoading = false;
      })

      // ✅ getForwardOrderItems
      .addCase(getForwardOrderItems.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getForwardOrderItems.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.forwardItems = payload.data.wholesalerData;
        }
        state.isLoading = false;
      })
      .addCase(getForwardOrderItems.rejected, (state, action) => {
        state.errorMessage = "Failed to fetch forward order items";
        state.isLoading = false;
      })

      // ✅ updateOrder — added this block
      .addCase(updateOrder.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateOrder.fulfilled, (state, action) => {
        if (action.payload?.data?.orders) {
          state.orders = action.payload.data.orders;
        }
        state.isLoading = false;
      })
      .addCase(updateOrder.rejected, (state, action) => {
        // @ts-expect-error
        state.errorMessage = action.payload?.message || "Failed to update order";
        state.isLoading = false;
      });
  },
});

export const { resetOrderState,clearForwardOrderItems, } = orderSlice.actions;
export default orderSlice.reducer;
